import { Button } from "react-bootstrap";
import { DateHelper } from "../../../../../helper";
import { RequestType, requestStatus, requestTypeDetail, requestTypes } from "../../../../../constants";
import { ApprovalStatus, FontFa } from "../../../../../components";
import { ColumnsType } from "antd/lib/table";
import { downloadExcel } from "react-export-table-to-excel";
import { TableHelpers } from "../../../../../helper/TableHelper";

export const useCodeProcessColumns = () => {
  const columns: ColumnsType<any> = [
    {
      title: "Mã YC",
      dataIndex: "id",
      key: "id",
      align: "center" as const,
      width: "100px",
      ...TableHelpers.searchInput({ dataIndex: "id" }),
    },
    {
      title: "Ngày tạo",
      dataIndex: "createdDateTime",
      key: "createdDateTime",
      render: (text: string) => DateHelper.formatDateToString(text),
      align: "center" as const,
      width: "150px",
      ...TableHelpers.searchRangePicker({ dataIndex: "createdDateTime" }),
    },
    {
      title: "Người tạo",
      dataIndex: "createdByName",
      key: "createdByName",
      width: "200px",
      ...TableHelpers.searchInput({ dataIndex: "createdByName" }),
    },
    {
      title: "Yêu cầu",
      dataIndex: "eRequestType",
      key: "eRequestType",
      render: (text: string) => (
        <div className={`flag ${requestTypeDetail[text as RequestType].flag}`}>{requestTypes[text]}</div>
      ),
      width: "100px",
      filters: [
        {
          text: "Nội bộ",
          value: "Internal",
        },
        {
          text: "Bên ngoài",
          value: "External",
        },
      ],
      onFilter: (status: any, record) => status.includes(record.eRequestType),
    },
    {
      title: "Mô tả",
      dataIndex: "eDescription",
      key: "eDescription",
      ...TableHelpers.searchInput({ dataIndex: "eDescription" }),
      onCell: () => {
        return {
          style: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            maxWidth: "400px", // optional max width to constrain very long content
          },
        };
      },
    },
    {
      title: "Trạng thái",
      dataIndex: "eRequestStatus",
      key: "eRequestStatus",
      width: "150px",
      render: (text: string) => <ApprovalStatus status={text} />,
      filters: [
        {
          text: "Đang đợi duyệt",
          value: requestStatus.submitted + "InProgress",
        },
        {
          text: "Đang thực hiện",
          value: requestStatus.inProgress,
        },
        {
          text: "Đã hoàn tất",
          value: requestStatus.completed,
        },
        {
          text: "Đã bị từ chối",
          value: requestStatus.rejected,
        },
      ],
      onFilter: (status: any, record) => {
        if (status === requestStatus.rejected) return record.eRequestStatus.indexOf(status) === 0;
        return status.includes(record.eRequestStatus);
      },
    },
    {
      title: "Xuất tài liệu",
      dataIndex: "export",
      key: "export",
      align: "center" as const,
      width: 120,
      render: (text: string, record: any) => (
        <Button
          title="Xuất file"
          variant="outline-danger"
          onClick={(e: any) => {
            e.stopPropagation();
            const header = [
              "Người sử dụng",
              "mã nhân viên",
              "Bộ phận công tác",
              "Chức danh",
              "Đề nghị",
              "Chi tiết đề nghị",
              "Lý do/ Trình độ đào tạo",
              "Email",
              "SĐT",
            ];
            const body = JSON.parse(record.eContent);
            const mappedBody = body.map((record: any) => {
              const { id, ...bodyWithoutId } = record;
              return bodyWithoutId;
            });
            downloadExcel({
              fileName: "DS_CapCode_" + record.id,
              sheet: "Sheet1",
              tablePayload: {
                header,
                body: mappedBody,
              },
            });
          }}
        >
          <FontFa name="faPrint" size={"xs"} />
        </Button>
      ),
    },
  ];
  return { columns };
};
